module.exports = __webpack_public_path__ + "static/theory-of-simple-liquids-4758e9b3e2d965e46f9997ac63a57f60.jpg";